<template>
  <svg
    :key="occupationPercent"
    width="554"
    height="847"
    viewBox="0 0 554 847"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <!-- forma principal -->
    <path
      d="M277 674.675L100 569.782V116.675L277 2.38072L454 116.675V569.782L277 674.675Z"
      :fill="'url(#paint0_linear_' + occupationPercent + ')'"
      stroke="black"
      stroke-width="4"
    />
    <line x1="100" y1="189" x2="100" y2="787" stroke="black" stroke-width="4" />
    <line x1="454" y1="189" x2="454" y2="787" stroke="black" stroke-width="4" />
    <line x1="98" y1="487.5" x2="456" y2="487.5" stroke="black" />
    <line x1="98" y1="188.5" x2="456" y2="188.5" stroke="black" />
    <rect x="2" y="789" width="550" height="56" fill="#D9D9D9" stroke="#959595" stroke-width="4" />

    <!-- texto central -->
    <text
      x="50%"
      y="42%"
      text-anchor="middle"
      dominant-baseline="middle"
      font-size="100"
      fill="#2c3e50"
    >
      {{ (occupationPercent * 100).toFixed(0) }}%
    </text>

    <defs>
      <linearGradient
        :id="'paint0_linear_' + occupationPercent"
        x1="277"
        y1="0"
        x2="277"
        y2="677"
        gradientUnits="userSpaceOnUse"
      >
        <stop :offset="1 - occupationPercent" :stop-color="backgroundColor" />
        <stop offset="0" :stop-color="occupationColor" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "silo-graph",
  props: {
    occupationPercent: { type: Number, required: true },
    occupationColor: { type: String, required: true },
    backgroundColor: { type: String, required: true }
  }
};
</script>
